import { Carousel, CarouselCaption, CarouselItem } from 'react-bootstrap';
import './Inicio.css';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNoticias } from '../actions/noticiaActions';
import { getAuthToken } from '../util/auth';

function InicioPage() {
  const dispatch = useDispatch();
  const { noticias = [] } = useSelector((state) => state.noticia || {});
  const UPLOADS_BASE_URL = process.env.REACT_APP_UPLOADS_BASE_URL;

  useEffect(() => {
    dispatch(fetchNoticias());
  }, [dispatch]);

  const getImageUrl = (foto) => {
    const token = getAuthToken();
    const timestamp = new Date().getTime();
    return `${UPLOADS_BASE_URL}/${foto}?token=${token}&timestamp=${timestamp}`;
  };

  const getTodayISO = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const normalizeDate = (value) => {
    if (!value) return null;
    const dateValue = String(value).split('T')[0].trim();

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
      return dateValue;
    }

    const match = dateValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (match) {
      const [, day, month, year] = match;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    return null;
  };

  const isNoticiaVisible = (noticia) => {
    const today = getTodayISO();
    const startDate = normalizeDate(noticia.fecha);
    const endDate = normalizeDate(noticia.fechafin) || startDate;

    if (!startDate || !endDate) return false;
    return startDate <= today && today <= endDate;
  };

  const visibleNoticias = noticias.filter(isNoticiaVisible);

  return (
    <main className="inicio-page">
      <section className="inicio-hero">
        <div className="inicio-hero-media" aria-hidden="true">
          {visibleNoticias.length > 0 ? (
            <Carousel className="inicio-carousel" controls={visibleNoticias.length > 1} indicators={visibleNoticias.length > 1} fade>
              {visibleNoticias.map((noticia, index) => (
                <CarouselItem key={noticia.id}>
                  <img src={noticia.foto ? getImageUrl(noticia.foto) : "/assets/ciab1.png"} alt={noticia.titulo || `Noticia ${index + 1}`} />
                  <CarouselCaption>
                    <span>Actualidad institucional</span>
                    <h2>{noticia.titulo}</h2>
                  </CarouselCaption>
                </CarouselItem>
              ))}
            </Carousel>
          ) : (
            <img className="inicio-hero-fallback" src="/assets/ciab1.png" alt="Colegio de Ingenieros Agronomos de Tarija" />
          )}
        </div>

        <div className="inicio-hero-overlay" />

        <div className="inicio-hero-content">
          <img className="inicio-brand" src="/assets/ciab_logo.png" alt="CIAB Tarija" />
          <div className="inicio-title-group">
            <p>Colegio de Ingenieros Agronomos de Bolivia</p>
            <h1>Filial Tarija</h1>
          </div>
        </div>
      </section>

      <section className="inicio-summary" aria-label="Resumen institucional">
        <div>
          <strong>Gestion institucional</strong>
          <span>Socios, cuotas, certificados e ingresos en un solo sistema.</span>
        </div>
        <div>
          <strong>Certificacion digital</strong>
          <span>Validacion publica mediante codigo y consulta en linea.</span>
        </div>
        <div>
          <strong>Filial Tarija</strong>
          <span>Informacion vigente para el trabajo administrativo diario.</span>
        </div>
      </section>
    </main>
  );
}

export default InicioPage;
